export enum SCREEN_QUERY {
    SMALL = '(max-width: 479px)',
    MEDIUM = '(min-width: 480px) and (max-width: 1399px)',
    LARGE = '(min-width: 1400px)',
}

export enum PROBLEM_SIDE_PANEL_MODE {
    CLOSED = 'closed',
    INFO = 'info',
    VARIANTS = 'variants',
}
